import './App.scss';
import React from 'react';
import Router from './router/Router';


function App() {
  return (
   <div>
   <Router />
  

   </div>
  );
}

export default App;
